import uniq from 'lodash/uniq';
import { ANALYTICS_DATA_PERSIST } from '../../constants';
const initialState = {
    plpViewItems: [],
    favouriteViewItems: [],
    viewPromotionItems: [],
};
const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ANALYTICS_DATA_PERSIST:
            const { plpViewItems, favouriteViewItems, viewPromotionItems } = state;
            const { payload: { plpViewItems: nextPlpViewItems = '', favouriteViewItems: nextFavouriteViewItems = '', viewPromotionItems: nextViewPromotionItems = '' } = {} } = action;
            return {
                ...state,
                plpViewItems: uniq([...plpViewItems, nextPlpViewItems]),
                favouriteViewItems: uniq([...favouriteViewItems, nextFavouriteViewItems]),
                viewPromotionItems: uniq([...viewPromotionItems, nextViewPromotionItems]),
            };
        default:
            return state;
    }
};
export default analyticsReducer;
